import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=66a36bea&scoped=true"
import script from "./solution.vue?vue&type=script&lang=js"
export * from "./solution.vue?vue&type=script&lang=js"
import style0 from "./solution.vue?vue&type=style&index=0&id=66a36bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a36bea",
  null
  
)

export default component.exports